export function defined(d) {
    return d !== undefined && d !== null && !Number.isNaN(d);
}
/**
 * Sort data similar with Array.prototypo.sort.
 */
export const Sort = (options) => {
    const { callback } = options;
    return (data) => (Array.isArray(data) ? [...data].sort(callback) : data);
};
Sort.props = {};
//# sourceMappingURL=sort.js.map